module.exports = __webpack_public_path__ + "static/me-photo-hero-c21aebd969b7319502831bbc1a19ae7f.webp";